import React from 'react';
import { Link } from 'react-router-dom';
import HttpManager from '../utils/HttpManager';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'

function Login() {

    const navigate = useNavigate();

    const [userEmail, setUserEmail] = useState('');
    const [password, setPassword] = useState('');
    const [stayLoggedIn, setStayLoggedIn] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    // Load user from localStorage on component mount
    useEffect(() => {
        const storedUser = localStorage.getItem('User');

        if (storedUser) {
            navigate('/Dashboard');
        }
    }, [navigate]);

    const VerifyLogin = async () => {

        const newErrors = {};

        if (!userEmail.trim()) {
            newErrors.userEmail = 'User email is required';
        }

        if (!password.trim()) {
            newErrors.password = 'Password is required';
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {

            setLoading(true);

            const credentialsModel = {
                UserEmail: userEmail,
                Password: password,
                StayLoggedIn: stayLoggedIn
            };

            try {

                const loginResponse =
                    await new HttpManager(navigate)
                        .post('/User/VerifyLogin', credentialsModel);

                if (
                    loginResponse.IsSuccess === true &&
                    loginResponse.Message === "Login Successful"
                ) {

                    localStorage.setItem(
                        "User",
                        JSON.stringify(loginResponse.Data)
                    );

                    navigate('/Dashboard');

                }
                else {

                    Swal.fire({
                        title: "Login Failed",
                        text: loginResponse.Message,
                        icon: "error"
                    });

                }

            }
            catch (error) {

                Swal.fire({
                    title: "Login Failed",
                    text: "Login failed due to technical error, kindly retry after sometime",
                    icon: "error"
                });

            }
            finally {

                setLoading(false);

            }
        }
    };


    return (
        <div className="d-flex justify-content-center align-items-center vh-100 w-100">

            <main className="form-signin w-100 m-auto">

                <form>

                    <div className="text-center mb-4">

                        <img
                            className="mb-4"
                            src="/DecipherX_Logo1.svg"
                            alt="decipherX Logo"
                            width="102"
                            height="87"
                        />

                    </div>


                    {/* Email */}
                    <div className="form-floating my-3">

                        <input
                            type="email"
                            className={`form-control ${
                                errors.userEmail ? 'is-invalid' : ''
                            }`}
                            id="txtEmail"
                            placeholder="User Email"
                            value={userEmail}
                            onChange={(e) =>
                                setUserEmail(e.target.value)
                            }
                        />

                        <label htmlFor="txtEmail">
                            User Email
                        </label>

                        {
                            errors.userEmail &&
                            <div className="invalid-feedback">
                                {errors.userEmail}
                            </div>
                        }

                    </div>


                    {/* Password */}
                    <div className="form-floating mt-3 mb-2">

                        <input
                            type="password"
                            className={`form-control ${
                                errors.password ? 'is-invalid' : ''
                            }`}
                            id="txtPassword"
                            placeholder="Password"
                            value={password}
                            onChange={(e) =>
                                setPassword(e.target.value)
                            }
                        />

                        <label htmlFor="txtPassword">
                            Password
                        </label>

                        {
                            errors.password &&
                            <div className="invalid-feedback">
                                {errors.password}
                            </div>
                        }

                    </div>


                    {/* Forgot Password */}
                    <div className="text-end mb-3">

                        <Link
                            to="/ForgotPassword"
                            style={{
                                textDecoration: "none"
                            }}
                        >
                            Forgot Password?
                        </Link>

                    </div>


                    {/* Stay logged in */}
                    <div className="form-check text-start my-3">

                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="stayLoggedIn"
                            checked={stayLoggedIn}
                            onChange={(e) =>
                                setStayLoggedIn(e.target.checked)
                            }
                        />

                        <label
                            className="form-check-label"
                            htmlFor="stayLoggedIn"
                        >
                            Stay Logged In
                        </label>

                    </div>


                    {/* Login */}
                    <button
                        className="btn btn-primary w-100 py-2"
                        type="button"
                        onClick={VerifyLogin}
                        disabled={loading}
                    >

                        {
                            !loading
                                ? "Login"
                                : (
                                    <>
                                        <span className="dot dot1 mx-2 text-center"></span>
                                        <span className="dot dot2 mx-2"></span>
                                        <span className="dot dot3 mx-2"></span>
                                    </>
                                )
                        }

                    </button>


                    {/* Register */}
                    <div className="text-end my-3">

                        <label className="form-check-label">
                            New User?
                        </label>

                        <Link
                            to="/Register"
                            style={{
                                textDecoration: "none"
                            }}
                        >
                            {" "}Sign Up
                        </Link>

                    </div>


                    <p className="mt-5 mb-3 text-body-secondary">
                        decipherX © 2026
                    </p>

                </form>

            </main>

        </div>
    );
}

export default Login;